import { useState } from 'react';
import { categories } from '@/mocks/homeData';

const HeroSection = () => {
  const [selectedCat, setSelectedCat] = useState('');

  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    setSelectedCat(url);
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
      setSelectedCat('');
    }
  };

  return (
    <section className="relative w-full min-h-screen flex flex-col">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20collage%20of%20minimalist%20fashion%20items%20and%20sneakers%20floating%20in%20organized%20chaos%20on%20warm%20sand%20and%20terracotta%20gradient%20background%2C%20soft%20diffused%20morning%20light%2C%20magazine%20editorial%20aesthetic%2C%20watercolor%20texture%20overlay%2C%20earth%20tone%20neutral%20palette%20with%20subtle%20gold%20accents%2C%20elegant%20contemporary%20composition&width=1600&height=900&seq=hero-bg-june26-3&orientation=landscape"
          alt="Hoobuy Spreadsheet produtos coleção"
          title="Hoobuy Spreadsheet em Português - Coleção de Produtos"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-6 md:px-12 pt-24">
        <div className="w-full flex flex-col lg:flex-row items-center lg:items-start gap-12 lg:gap-20 max-w-7xl mx-auto">
          <div className="lg:w-1/2 text-center lg:text-left">
            <p className="text-background-50/70 text-xs md:text-sm font-medium uppercase tracking-widest mb-4">Atualizado 2026</p>
            <h1 className="text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-heading font-bold text-background-50 leading-[1.05]">
              O Melhor Hoobuy<br />
              Spreadsheet em<br />
              Português
            </h1>
            <p className="mt-6 text-background-50/80 text-base md:text-lg leading-relaxed max-w-lg">
              Encontre milhares de produtos selecionados no maior <strong>Hoobuy Spreadsheet</strong> para Brasil e Portugal. Sneakers, roupas, acessórios e fornecedores verificados.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 bg-primary-500 text-background-50 text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Explorar Spreadsheet <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="lg:w-1/2 flex flex-col items-center justify-center w-full max-w-md">
            <div className="w-full bg-background-50/80 backdrop-blur-md rounded-2xl p-6 md:p-8">
              <p className="text-foreground-700 text-sm font-medium mb-4">Escolha uma categoria:</p>
              <div className="relative">
                <select
                  value={selectedCat}
                  onChange={handleSelect}
                  className="w-full h-12 px-4 pr-10 bg-background-50 border border-background-300 rounded-xl text-sm text-foreground-950 font-medium outline-none appearance-none cursor-pointer focus:border-primary-300 transition-colors"
                >
                  <option value="">Selecionar categoria...</option>
                  {categories.map((cat) => (
                    <option key={cat.nameEn} value={cat.url}>
                      {cat.name} ({cat.count} itens)
                    </option>
                  ))}
                </select>
                <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 pointer-events-none"></i>
              </div>
              <p className="mt-3 text-foreground-500 text-xs">
                14 categorias com links atualizados diariamente
              </p>
            </div>
          </div>
        </div>

        <div className="w-full max-w-7xl mx-auto mt-16 mb-8 px-0">
          <div className="relative rounded-3xl overflow-hidden h-[300px] md:h-[400px]">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20minimalist%20product%20collage%20featuring%20sneakers%20hoodies%20watches%20and%20accessories%20arranged%20in%20clean%20diagonal%20grid%2C%20warm%20sand%20and%20cream%20background%20with%20subtle%20grain%20texture%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20catalog%20photography%20style%2C%20elegant%20composition%20with%20harmonious%20earth%20tone%20color%20palette&width=1600&height=500&seq=hero-collage-june26-3&orientation=landscape"
              alt="Hoobuy Spreadsheet collage de produtos"
              title="Hoobuy Spreadsheet - Milhares de produtos"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;